import apiClient from '@/utilities/api-client';
import { BUSINESS_BILLING_ID } from '@/constants';

export async function getMenuItems(userType) {
  let items = [];
  const { data } = await apiClient.get('/api/me/accounts/menu-conditions');
  const sellerItems = [
    {
      text: 'My Insights',
      link: '/account/seller-stats/',
      icon: 'fa-chart-pie-simple',
      name: 'my insights',
    },
    {
      text: 'My Statements',
      link: '/account/statements/',
      icon: 'fa-file-lines',
      name: 'my statements',
    },
    {
      text: 'My Submissions',
      link: '/account/submissions/',
      icon: 'fa-file-lines',
      name: 'my submissions',
    },
    {
      text: 'My Seller Profile',
      link: '/account/seller-details/',
      icon: 'fa-briefcase',
      name: 'my seller profile',
      has_divider: true,
    },
  ];
  if (data.is_seller) {
    items = [...sellerItems];
  }
  items.push({
    text: 'My Collections',
    link: '/account/collections/',
    icon: 'fa-folders',
    name: 'my collections',
  });

  items.push({
    text: 'My Profile',
    link: '/account/details/',
    icon: 'fa-user',
    name: 'my seller profile',
  });

  if (!data.is_freeloader) {
    if (data.subscribed) {
        items.push({
          text: 'Plan & Billing',
          link: '/account/subscription/',
          icon: 'fa-address-card',
          name: 'Plan & Billing',
        });

      if (data.planName === 'Annual') {
        items.push({
          text: 'Refer a Friend',
          link: '/account/refer-a-friend/',
          icon: 'fas fa-user-plus',
          name: 'refer a friend',
        });
      }
    }
  }
  // TODO: need to hide only for business plan for now, will update later
  if (data.ever_subscribed && data.planBillingId !== BUSINESS_BILLING_ID) {
    items.push({
      text: 'Invoices',
      link: '/account/invoices/',
      icon: 'fa-file-invoice-dollar',
      name: 'invoices',
    });
  }

  items.push({
    text: 'My Downloads',
    link: '/account/downloads/',
    icon: 'fa-download',
    name: 'my downloads',
  });

  if (data.has_active_team_membership) {
    if (data.is_admin_of_team) {
      const teamItems = [];
      if (!data.uses_new_teams_service) {
        teamItems.push({
          text: 'Team Profile',
          link: '/account/team/details/',
          icon: 'fa-user-group',
          name: 'team profile',
        });
        // TODO: need to hide only for business plan for now, will update later
        if (data.planBillingId !== BUSINESS_BILLING_ID) {
          teamItems.push({
            text: 'Team Invoices',
            link: '/account/team/invoices/',
            icon: 'fa-file-invoice-dollar',
            name: 'team invoices',
          });
        }
      }

      teamItems.push({
        text: 'Manage Members',
        link: '/account/team/manage-members/',
        icon: 'fa-user-group',
        name: 'manage members',
      });

      items = [...items, ...teamItems];
    } else if (data.uses_new_teams_service && data.has_active_team) {
      const teamItems = [];
      teamItems.push({
        text: 'Manage Members',
        link: '/account/team/manage-members/',
        icon: 'fa-user-group',
        name: 'manage members',
      });

      items = [...items, ...teamItems];
    }
  } else {
    items.push({
      text: 'Create a Team Plan',
      link: '/pricing/teams/',
      icon: 'fa-user-group',
      name: 'create a team plan',
    });
  }

  if (userType === 'paid') {
    items.push({
      text: 'Content ID Claims',
      link: '/account/claims/',
      icon: 'fa-file-exclamation',
      name: 'content id claims',
    });
  }

  return items;
}

export async function getFooterMenuItems() {
  const { data } = await apiClient.get('/api/me/accounts/menu-conditions');
  if (!data.is_seller) {
    return [];
  }
  return [
    {
      text: 'Upload Rules',
      link: 'https://www.motionartistshub.com/helpcenter/motion-array-upload-rules',
    },
    {
      text: 'Producer terms of service',
      link: '/producer-terms-of-service/',
    },
    {
      text: 'Help center',
      link: 'https://www.motionartistshub.com/helpcenter',
    },
    {
      text: 'Artist Hub',
      link: 'https://www.motionartistshub.com/',
    },
  ];
}
